'use client';
import { useEffect } from 'react';
 import Header from'@/components/common/Header';
 import Footer from'@/components/common/Footer';
 import ContactInfoCards from'./components/ContactInfoCards';
 import ContactForm from'./components/ContactForm';
 import GoogleMap from'./components/GoogleMap';
 import SocialLinks from'./components/SocialLinks';

export default function ContactPage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach((el) => observer?.observe(el))

    return () => observer?.disconnect();
  }, [])

  return (
    <>
      <Header />
      <main className="pt-32">
        {/* Page Header */}
        <section className="pb-20 bg-background">
          <div className="max-w-5xl mx-auto px-6 text-center reveal">
            <div className="flex items-center justify-center gap-4 mb-6">
              <div className="w-[2px] h-4 bg-amber-500" />
              <span className="text-[10px] uppercase tracking-[0.3em] font-bold text-zinc-400">
                Get In Touch
              </span>
            </div>
            <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold tracking-tight mb-8 text-white">
              Let's Start<br />Your Project
            </h1>
            <p className="text-lg md:text-xl text-zinc-400 max-w-3xl mx-auto leading-relaxed">
              Have a project in mind? We'd love to hear from you. Visit our office in Ulhasnagar or send us a message and we'll respond within 24 hours.
            </p>
          </div>
        </section>

        {/* Contact Info Cards */}
        <section className="py-20 bg-background">
          <div className="max-w-7xl mx-auto px-6">
            <ContactInfoCards />
          </div>
        </section>

        {/* Contact Form & Map */}
        <section className="py-20 bg-zinc-950 border-y border-zinc-800">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <ContactForm />
              <div className="space-y-8">
                <GoogleMap />
                <SocialLinks />
              </div>
            </div>
          </div>
        </section>

        {/* Additional Info */}
        <section className="py-20 bg-background">
          <div className="max-w-4xl mx-auto px-6 text-center reveal">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Why Work With Us?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
              {[
                {
                  title: 'Fast Response',
                  description: 'We respond to all inquiries within 24 hours',
                },
                {
                  title: 'Transparent Pricing',
                  description: 'Clear quotes with no hidden costs',
                },
                {
                  title: 'Dedicated Support',
                  description: '24/7 support throughout your project',
                },
              ]?.map((item, idx) => (
                <div
                  key={idx}
                  className="p-6 bg-zinc-900 border border-zinc-800 rounded-2xl"
                >
                  <h3 className="text-lg font-bold text-white mb-2">{item?.title}</h3>
                  <p className="text-sm text-zinc-400">{item?.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}